/**
 * Roles de la plataforma (role_id de la BD).
 *
 *  - Superadmin (4): todo lo del admin + Servidores y registro de actividad.
 *  - Admin (1): negocio (empresas, centralitas, chatbots, costes, usuarios).
 *  - Editor (2) y Viewer (3): su proyecto y su empresa.
 *
 * Usar siempre isAdminRole() en lugar de "role === 1": el superadmin puede todo
 * lo que puede un admin. El backend aplica las mismas reglas por su cuenta.
 */
export const ROLES = { ADMIN: 1, EDITOR: 2, VIEWER: 3, SUPERADMIN: 4 }

// Roles con permisos de administrador (para requiredPermissions del menú)
export const ADMIN_ROLES = [ROLES.ADMIN, ROLES.SUPERADMIN]

export const isAdminRole = role => ADMIN_ROLES.includes(Number(role))
export const isSuperadminRole = role => Number(role) === ROLES.SUPERADMIN
